export default __webpack_public_path__ + "static/media/greenMessageIcon.784008e8.svg";